import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import router from '@/router'
import { RouteLocationNormalized } from 'vue-router'
import { store, RootState } from './store'
import { UserActionTypes } from './store/modules/user/action-types'
import { PermissionActionType } from './store/modules/permission/action-types'
import getPageTitle from '@/utils/get-page-title'
import { NotificationActionTypes } from './store/modules/notification/action-types'

NProgress.configure({ showSpinner: false })

function resolveFirstAccessiblePath(routes: any[] = []): string {
  for (const route of routes) {
    if (route.children?.length) {
      const childPath = resolveFirstAccessiblePath(route.children)
      if (childPath) return childPath
    }
    if (route.path) return route.path
  }
  return '/'
}

// 移除 next 参数，完全改用 return 模式
router.beforeEach(async(to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  NProgress.start()
  document.title = getPageTitle(to.meta.title)

  const isWhitePath = to.path === '/login' || to.path === '/set-password' || to.redirectedFrom?.path === '/login'

  if (isWhitePath) {
    NProgress.done()
    return true // 相当于 next()
  }

  const state = store.state as RootState

  // 检查是否已登录并有权限
  if (!state.user.userId) {
    try {
      // 获取用户信息
      await store.dispatch(UserActionTypes.ACTION_GET_USER_INFO, undefined)
      const roles = state.user.roles

      // 生成路由
      await store.dispatch(PermissionActionType.ACTION_SET_ROUTES, roles)
      const dynamicRoutes = state.permission.dynamicRoutes

      console.log('正在动态注册路由，数量:', dynamicRoutes.length)
      // 初始化消息系统
      store.dispatch(NotificationActionTypes.ACTION_GET_UNREAD_COUNT, undefined)
      store.dispatch(NotificationActionTypes.ACTION_INIT_WEBSOCKET, undefined)
      dynamicRoutes.forEach((route: any) => {
        try {
          if (route.path) router.addRoute(route)
        } catch (e) {
          console.error('注册路由失败:', route.path, e)
        }
      })

      // 重新匹配
      const resolvedTarget = router.resolve(to.fullPath)
      const hasMatched = resolvedTarget.matched.length > 0
      console.log('路由重新匹配结果:', { path: to.fullPath, matchedCount: resolvedTarget.matched.length })

      if (hasMatched) {
        return { ...to, replace: true }
      } else {
        const firstPath = resolveFirstAccessiblePath(dynamicRoutes)
        console.warn('当前路径无法匹配，尝试跳转到首个可用菜单:', firstPath)
        return { path: firstPath, replace: true }
      }
    } catch (err) {
      console.error('权限守卫异常:', err)
      await store.dispatch(UserActionTypes.ACTION_RESET_TOKEN, undefined)
      NProgress.done()
      return `/login?redirect=${to.path}`
    }
  }

  // 处理根路径重定向
  if (to.path === '/' && state.permission.dynamicRoutes.length) {
    const firstPath = resolveFirstAccessiblePath(state.permission.dynamicRoutes)
    NProgress.done()
    return { path: firstPath, replace: true }
  }

  // 已登录情况下的权限处理
  const menuId = to.meta.menuId as number
  if (menuId) {
    await store.dispatch(PermissionActionType.ACTION_SET_PERMISSIONS, menuId)
  }

  return true // 允许导航
})

router.afterEach(() => {
  NProgress.done()
})

